export default {
  Usuario: 'User',
  Contraseña: 'Password',
  'Iniciar Sesión': 'Login',
  '¿Olvidó su contraseña?': 'Forgot your password?',
  Recupérala: '',
  Versión: 'Version',
  BIENVENIDO: 'WELCOME',
  'AGUA DULCE': 'FRESH WATER',
  'AGUA MAR': 'SEA WATER',
  Mortalidad: 'Mortality',
  'Selecciona un centro': 'Select a center',
  'Selecciona un módulo': 'Select a module',
  MORTALIDAD: 'MORTALITY',
  ESTADOS: 'STATES',
  ACCESO: 'ACCESS',
  Hola: 'Hi',
  Usuarios: 'Users',
  '¿No eres': 'Are not you',
  'Cambia de Usuario': 'Change User',
  Siguiente: 'Next',
  'Utiliza al menos 8 caracteres': 'Use at least 8 characters',
  'Este campo es obligatorio': 'This field is required.',
  'Introduzca un e-mail valido': 'Enter a valid email',
  '¿Has olvidado tu contraseña?': 'Have you forgotten your password?',
  'RECUPERA TU CUENTA': 'RECOVER YOUR ACCOUNT',
  'Ingresa una dirección de correo electrónico que puedas consultar ahora':
    'Enter an email address that you can check now',
  'Volver a Iniciar Sesión': 'Return to Login',
  'Formulario Mortalidad': 'Mortality Form',
  'Formulario Estados': 'States Form',
  'Selecciona una piscicultura': 'Select a fish farm',
  'Selecciona una fecha': 'Select a date',
  'Selecciona una sala': 'Select a room',
  Estanque: 'Pond',
  ESTANQUE: 'POND',
  JAULA: 'CAGE',
  JAULAS: 'CAGES',
  MODULOS: 'MODULES',
  'Selecciona una jaula': 'Select a cage',
  'TIPO DE MORTALIDAD': 'MORTALITY TYPE',
  'N° DE MORTALIDAD': 'MORTALITY N°',
  ESTADO: 'STATE',
  TIPOS: 'TYPES',
  'Selecciona el tipo de mortalidad': 'Select the mortality type',
  'Buscar Estanque': 'Search Tank',
  'BUSCAR ESTANQUE': 'SEARCH TANK',
  'BUSCAR JAULA': 'SEARCH CAGE',
  BUSCAR: 'SEARCH',
  ACEPTAR: 'OK',
  'Habla ahora': 'Speak now',
  'No lo he entendido': "I didn't understand",
  'Presione para iniciar': 'Press to start',
  'Pulsa para pausar': 'Press to pause',
  'Pulsa para intentarlo de nuevo': 'Press to try again',
  'Pulsa para activar microfono': 'Press to activate microphone',
  Si: 'Yes',
  Cosecha: 'Harvest',
  Siembra: 'Sowing',
  'Cambio de Estado.': 'Status Change.',
  'Nuevo Estado: ': 'New State: ',
  'Estado Actual: ': 'Current State: ',
  'Eliminar registros': 'Delete records',
  '¿Estás seguro de eliminar los registros seleccionados?':
    'Are you sure to delete the selected records?',
  '¿Estás seguro de enviar los registros seleccionados?':
    'Are you sure to send the selected records?',
  Estados: 'States',
  'Registro Pendiente: ': 'Pending Record: ',
  'Total de mortalidad ingresada: ': 'Total Mortality Entered: ',
  Enviar: 'Send',
  'Fecha de mortalidad: ': 'Mortality Date: ',
  LABORATORIO: 'LABORATORY',
  'Todos los Derechos Reservados': 'All Rights Reserved',
  'Recuperar Contraseña': 'Recover password',
  '¿Ya tiene su contraseña?': 'Already have your password?',
  'Inicie sesión': 'Login',
  Guardar: 'Save',
  GUARDAR: 'SAVE',
  ENVIAR: 'SEND',
  Guardado: 'Saved',
  'El registro se guardó con éxito': 'The record was saved successfully',
  'Campo vacio. Ingrese un valor de mortalidad para': 'Empty field. Enter a mortality value for',
  'en fecha': 'on date',
  '¡Gracias!': 'Thank you!',
  'Formulario enviado correctamente': 'Form submitted successfully',
  'VOLVER AL INICIO': 'BACK TO HOME',
  'Cerrar sesión': 'Logout',
  '¿Seguro que quieres cerrar sesión?': 'Are you sure you want to log out?',
  Cancelar: 'Cancel',
  'Formulario de Estados': 'States Form',
  'Error al obtener su tipo de perfil. Intente mas tarde.':
    'Failed to obtain your profile type. Try again later',
  'ESTADO ACTUAL': 'CURRENT STATE',
  'NUEVO ESTADO': 'NEW STATE',
  Seleccione: 'Select',
  Prueba: 'Test',
  Activo: 'Active',
  Inactivo: 'Inactive',
  Manejo: 'Handle',
  Vacunación: 'Vaccination',
  Recepción: 'Reception',
  Despacho: 'Dispatch',
  Vacío: 'Empty',
  Reparación: 'Repair',
  'BUSCAR CENTRO': 'SEARCH CENTER',
  'BUSCAR PISCICULTURA': 'SEARCH FISH FARM',
  'Error al enviar la mortalidad. Intente mas tarde.': 'Failed to send mortality. Try again later.',
  'Error al enviar los estados. Intente mas tarde.': 'Failed to send states. Try again later',
  'Ocurrió un error. Intente mas tarde.': 'An error occurred. Try again later.',
  'Solicitud Exitosa': 'Success',
  'Se envió un enlace de recuperación a su correo electrónico. Si no lo recibe en unos segundos revise su bandeja de spam.':
    "A recovery link was sent to your email. If you don't receive it in a few seconds, check your spam folder.",
  'Recibirás un correo electrónico con un link para que puedas reestablecer tu contraseña':
    'You will receive an email with a link so you can reset your password',
  Idioma: 'Language',
  'Acabas de reestablecer tu contraseña': 'Acabas de reestablecer tu contraseña',
  'Se envió enlace a ': 'Link was sent to ',
  Registros: 'Records',
  Inglés: 'English',
  Español: 'Spanish',
  Aceptar: 'Ok',
  FORMULARIO: 'FORM',
  SALAS: 'ROOMS',
  ESTANQUES: 'TANKS',
  'Formulario Laboratorio': 'Laboratory Form',
  'Selecciona un estanque': 'Select a tank',
  'Hora de muestra': 'Sample Time',
  'BUSCAR MEDICIONES': 'FIND MEASUREMENTS',
  'BUSCAR MORTALIDAD': 'SEARCH MORTALITY',
  MEDICIONES: 'MEASUREMENTS',
  'INGRESA DATOS': 'ENTER DATA',
  'Selecciona el area': 'Select the area',
  'Nombre del servicio': 'Service Name',
  'BUSCAR SERVICIO': 'SEARCH FOR SERVICE',
  'Seleccione un trabajo': 'Select a job',
  'Seleccione una faena': 'Select a chore',
  TRABAJOS: 'JOBS',
  TRABAJO: 'WORK',
  'NO TRABAJO': 'NO WORK',
  FAENAS: 'CHORES',
  Trabajos: 'Jobs',
  Faenas: 'Chores',
  Centros: 'Centers',
  'DECLARAR FALLO': 'DECLARE FAILURE',
  OBSERVACIONES: 'OBSERVATIONS',
  Advertencia: 'Warning:',
  'Ej. Se llevó a cabo con un excelente rendimiento':
    'For example, it was carried out with excellent performance.',
  Duplicado: 'Duplicate record',
  Embarcación: 'Boarding',
  Centro: 'Center',
  Fecha: 'Date',
  'Ingresar % de Falla': 'Enter % of Failure',
  'Cambiar % de Falla': 'Change % of Failure',
  'No ingresa relevo': 'Does not enter relief',
  'INGRESAR OTRO SERVICIO': 'ENTER ANOTHER SERVICE',
  CONTINUAR: 'CONTINUE',
  'DECLARAR FALLA': 'DECLARE FAILURE',
  DOTACIÓN: 'ENDOWMENT',
  BARCO: 'SHIP',
  BUZO: 'DIVER',
  HIDRÁULICO: 'HYDRAULIC',
  'Su sesión ha expirado, debe ingresar nuevamente.':
    'Your session has expired, please log in again.',
  Enero: 'January',
  Febrero: 'February',
  Marzo: 'March',
  Abril: 'April',
  Mayo: 'May',
  Junio: 'June',
  Julio: 'July',
  Agosto: 'August',
  Septiembre: 'September',
  Octubre: 'October',
  Noviembre: 'November',
  Diciembre: 'December',
  'NO SELECCIONAR JAULAS': 'DO NOT SELECT CAGES',
  Continuar: 'Continue',
  'Valida la siguiente información': 'Validate the following information',
  'No uso de ROV': 'No use of ROV',
  'Uso de ROV': 'Use of ROV',
  NOMBRE: 'NAME',
  'Seleccionar Todas': 'Select All',
  Alertas: 'Alerts',
  NECROPSIA: 'NECROPSY',
  'REGISTROS NECROPSIA': 'NECROPSY RECORDS',
  'RECEPCIÓN COMBUSTIBLE': 'FUEL RECEIPT',
  'CONSUMO COMBUSTIBLE': 'FUEL CONSUMPTION',
  SALUD: 'HEALTH',
  LOGISTICA: 'LOGISTICS',
  'Registros necropsia': 'Necropsy records',
  'Necesitas estar conectado a internet para poder enviar los formularios':
    'You need to be connected to the internet to send the forms',
  Resumen: 'Summary',
  'Foto externa general': 'General external photo',
  'Foto interna general': 'General internal photo',
  'Foto interna branquias': 'Internal gill photo',
  'Foto adicional': 'Additional photo',
  'Nueva ficha Necropsia': 'New necropsy form',
  'Comenzar Ficha': 'Start form',
  'FOTO SALMÓN EXTERNA': 'EXTERNAL SALMON PHOTO',
  'Sitúe el pescado completo dentro del margen': 'Place the whole fish within the frame',
  'Foto tomada con éxito': 'Photo taken successfully',
  'Repetir foto': 'Retake photo',
  'FOTO INTERNA BRANQUIAS': 'INTERNAL GILL PHOTO',
  'FOTO INTERNA GENERAL': 'GENERAL INTERNAL PHOTO',
  'La ficha fue guardada correctamente. ¿Desea crear una nueva ficha?':
    'The form was saved successfully. Do you want to create a new form?',
  'FICHA GUARDADA': 'FORM SAVED',
  Terminar: 'Finish',
  'Crear nueva ficha': 'Create new form',
  'FOTO ADICIONAL': 'ADDITIONAL PHOTO',
  Comentarios: 'Comments',
  'Escribe algo o deja un audio': 'Write something or leave an audio',
  Repetir: 'repeat',
  Salir: 'exit',
  'Tomar foto': 'Take photo',
  'Ficha N': 'Form N',
  Hora: 'Time',
  'Sin internet': 'No internet',
  'N° pedido': 'Order number',
  'Ingresar pedido manual': 'Enter order manually',
  'FOTO MEDIDOR FINAL': 'FINAL METER PHOTO',
  'Llena el estanque de combustible, y cuando hayas terminado, vuelve a tomar otra foto del medidor':
    'Fill the fuel tank, and when you are done, take another photo of the meter',
  'FOTO VARILLA FINAL': 'FINAL STICK PHOTO',
  'Sitúe punta de la varilla dentro del margen': 'Place the tip of the stick within the frame',
  'FOTO MEDIDOR INICIO': 'INITIAL METER PHOTO',
  'Toma una foto del medidor, antes de depositar el combustible.':
    'Take a photo of the meter before adding the fuel.',
  'Recepción combustible': 'Fuel reception',
  'Ingreso pedido manual': 'Manual order entry',
  'Fecha de entrega': 'Delivery date',
  Proveedor: 'Supplier',
  Volver: 'Back',
  'Iniciar prueba de agua': 'Start water test',
  'Registro medidor final': 'Final meter registration',
  'Ingrese el número que indica el medidor': 'Enter the number indicated by the meter',
  'Resumen recepción combustible': 'Fuel reception summary',
  'Varilla inicial': 'Initial stick',
  'Varilla final': 'Final stick',
  'Prueba de agua': 'Water test',
  'Medidor inicial': 'Initial meter',
  'Medidor final': 'Final meter',
  Registro: 'Registration',
  'Comprobante de entrega': 'Delivery receipt',
  'Confirmar recepción': 'Confirm reception',
  'Registro Guardado': 'Registration Saved',
  'Registro Enviado': 'Registration Sent',
  'Añadir foto': 'Add photo',
  'Cantidad de litros': 'Amount of liters',
  'Resultado de la prueba': 'Test result',
  'Selecciona positivo si la prueba señala que hay agua en el combustible, y negativo si la prueba señala que no hay agua en el combustible.':
    'Select positive if the test indicates that there is water in the fuel, and negative if the test indicates that there is no water in the fuel.',
  Positivo: 'Positive',
  Negativo: 'Negative',
  Enviando: 'Sending',
  'Ingrese el N° de folio del comprobante': 'Enter the receipt folio number',
  'FOTO COMPROBANTE DE ENTREGA': 'DELIVERY RECEIPT PHOTO',
  'Saque una foto del comprobante de entrega del proveedor':
    "Take a photo of the supplier's delivery receipt",
  'Selecciona un área a monitorear': 'Select an area to monitor',
  'FOTO VARILLA INICIAL': 'INITIAL STICK PHOTO',
  Bienvenido: 'Welcome',
  Omitir: 'Skip',
  Recuérdame: 'Remind me',
  'Inserta la varilla seca dentro del estanque de combustible, espera 15 segundos y presiona continuar para tomar la siguiente foto.':
    'Insert the dry stick into the fuel tank, wait 15 seconds, and press continue to take the next photo.',
  'Atención, si la prueba dio positiva, no debes depositar combustible en el estanque, informa a (Nombre encargado y teléfono).':
    'Attention, if the test is positive, do not deposit fuel in the tank, inform (Person in charge and phone number).',
  Atención: 'Attention',
  Entendido: 'Understood',
  'Hubo un error al enviar la orden, por favor reintente.':
    'There was an error sending the order, please try again',
  'Seleccione embarcación': 'Select vessel',
  'Buscar embarcación': 'Search vessel',
  Mon: 'Mon',
  Tue: 'Tue',
  Wed: 'Wed',
  Thu: 'Thu',
  Fri: 'Fri',
  Sat: 'Sat',
  Sun: 'Sun',
  'Declaración de fallas': 'Fault declaration',
  'Seleccione un trabajo y faena': 'Select a job and task',
}
